module.exports = __webpack_public_path__ + "static/media/audio-11.31e087ec.mp3";